module.exports = __webpack_public_path__ + "img/9788989456360.541b22ae.jpg";